import { Link } from '@mui/material';
import Typography from '@mui/material/Typography';
import { push } from 'utils/navigation/navigate';
import React, { FC } from 'react';
import { BreadcrumbsItemProps } from './BreadcrumbsItem.types';

export const BreadcrumbsItem: FC<BreadcrumbsItemProps> = (props) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    push(props.to);
  };

  const staticBreadcrumb = () => {
    return <Typography color="textPrimary">{props.children}</Typography>;
  };

  const linkingBreadcrumb = () => (
    <Link color="inherit" href={props.to} onClick={handleClick}>
      {props.children}
    </Link>
  );

  return props.static ? staticBreadcrumb() : linkingBreadcrumb();
};

export const BreadcrumbsLastItem: FC<BreadcrumbsItemProps> = (props) => {
  return <Typography color="textPrimary">{props.children}</Typography>;
};
